import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";

interface IProps {
    balance: number
}
export default function BalanceSourcesCard(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });


    return (
        <div className="card">
            <div className="card-body">

                <FlexRow className="mb-5">
                    <Icon icon="bullhorn" className="fs-2hx text-gray-600" />
                </FlexRow>
                <div className="d-flex flex-column">
                    <span className={`fw-bold fs-2x lh-1 ls-n2 mb-2 ${(props.balance > 0 ? "text-success" : props.balance < 0 ? "text-danger" : "text-gray-800")}`}>
                        {(props.balance > 0 ? "+" : "")}{moneyFormatter.format(props.balance)}
                    </span>
                    <div className="m-0">
                        <span className="fw-semibold fs-6 text-gray-500">Sources Balance</span>
                    </div>
                </div>

            </div>
        </div>
    )
}